import React, { useEffect, useState } from "react";
import { Button, ButtonVariant, Tooltip } from "@merge-api/merge-javascript-shared";
import { MonitorUp } from "lucide-react";
import useCustomizationContext from "../context/useCustomizationContext";
import { fetchCreateTestLinkToken } from "../../../../../api-client/APIClient";
import useCustomizationChangeCounts from "./useCustomizationChangeInformation";
import { getTenantConfigForMergeLink } from "../../../linked-accounts/AddTestLinkedAccountButton";
import { useMergeLink } from "@mergeapi/react-merge-link";
import MergeLinkIcon from "../../../../shared/MergeLinkIcon";
import useAppContext from "../../../../context/useAppContext";

const CustomizationViewPublishButtons = () => {
  const { user } = useAppContext();
  const [linkToken, setLinkToken] = useState<string | undefined>(undefined);
  const {
    integrationCustomizations,
    originalIntegrationCustomizations,
    organizationCustomization,
    originalOrganizationCustomization,
    logo,
    hasLogoChange,
    setModalTypeShown,
  } = useCustomizationContext();

  const { publishDisabled, hasValidationError } = useCustomizationChangeCounts(
    organizationCustomization,
    originalOrganizationCustomization,
    integrationCustomizations,
    originalIntegrationCustomizations,
    logo,
    hasLogoChange,
  );

  useEffect(() => {
    fetchCreateTestLinkToken(setLinkToken);
  }, [originalIntegrationCustomizations, originalOrganizationCustomization]);

  const tenantConfig = getTenantConfigForMergeLink();

  const { open, isReady } = useMergeLink({
    linkToken: linkToken,
    onSuccess: () => {},
    onExit: () => {
      fetchCreateTestLinkToken(setLinkToken);
    },
    ...tenantConfig,
  });

  return (
    <div className="flex flex-row gap-3">
      {!user.is_merge_link_button_disabled && (
        <Button
          size="sm"
          variant={ButtonVariant.SecondaryGray}
          leftIcon={<MergeLinkIcon size={12} />}
          onClick={() => (publishDisabled ? open() : setModalTypeShown("VIEW_CHANGES"))}
          loading={!isReady}
        >
          View Merge Link
        </Button>
      )}
      <Tooltip
        title={
          hasValidationError && publishDisabled
            ? "Please fix all errors before publishing."
            : undefined
        }
      >
        <Button
          size="sm"
          variant={ButtonVariant.PrimaryGray}
          leftIcon={<MonitorUp className="h-3 w-3" />}
          onClick={() => setModalTypeShown("PUBLISH")}
          disabled={publishDisabled}
        >
          Publish changes
        </Button>
      </Tooltip>
    </div>
  );
};

export default React.memo(CustomizationViewPublishButtons);
